import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ContractType } from 'src/app/models/entities/contract-type';
import { Period } from 'src/app/models/entities/period';
import { ContractTypeService } from 'src/app/services/contract-type.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PeriodService } from 'src/app/services/period.service';

@Component({
  selector: 'app-contract-type-add',
  templateUrl: './contract-type-add.component.html',
  styleUrls: ['./contract-type-add.component.css']
})
export class ContractTypeAddComponent implements OnInit {

  destroy$ = new Subject<void>();
  periods$: Observable<Period[]>;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractTypeService: ContractTypeService,
    private periodService: PeriodService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getPeriods();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      contractTypeCode: [""],
      contractTypeName: ["", Validators.required],
      periodId: ["", Validators.required],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      isActive: true
    })
  }

  getPeriods() {
    this.periods$ = this.periodService.getList().pipe(map(result => result.data));
  }

  add() {
    if (this.form.valid) {
      const contractType: ContractType = this.form.getRawValue();
      contractType.userId = this.userService.getUserId();
      this.contractTypeService.add(contractType).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/contract-type');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
